import PocketBase from "pocketbase";
var apiaddr = process.env.NODE_ENV === 'production' ? 'https://apiv2.site.photos/' : 'http://127.0.0.1:8090/';
const client = new PocketBase(apiaddr);
console.log(client);
// Export the client as a module
export default client;